(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["balnia-coloris"] && !Shopify.designMode) return;
  try {
    (function () {
    var cache = {};
    var echangeFait = false;

    function sectionDe(el) {
      var n = el;
      while (n && n.nodeType === 1) {
        if (n.id && n.id.indexOf('shopify-section-') === 0) return n;
        n = n.parentNode;
      }
      return null;
    }

    function urlSection(url, id) {
      var base = url.split('#')[0];
      return base + (base.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(id);
    }

    function charge(url, id) {
      var k = url + '|' + id;
      if (!cache[k]) {
        cache[k] = fetch(urlSection(url, id), { credentials: 'same-origin' }).then(function (r) {
          if (!r.ok) throw new Error('section ' + r.status);
          return r.text();
        });
        cache[k].catch(function () { delete cache[k]; });
      }
      return cache[k];
    }


    function rejoueScripts(scope) {
      var l = scope.querySelectorAll('script');
      for (var i = 0; i < l.length; i++) {
        var vieux = l[i];
        var neuf = document.createElement('script');
        for (var j = 0; j < vieux.attributes.length; j++) {
          neuf.setAttribute(vieux.attributes[j].name, vieux.attributes[j].value);
        }
        neuf.textContent = vieux.textContent;
        vieux.parentNode.replaceChild(neuf, vieux);
      }
    }


    function prepare(root, lien) {
      var url = lien.getAttribute('href');
      if (!url) return;
      if (root.getAttribute('data-ajax') === '1') {
        var sec = sectionDe(root);
        if (sec) charge(url, sec.id.replace('shopify-section-', ''));
        return;
      }
      if (lien.dataset.bcolPret) return;
      lien.dataset.bcolPret = '1';
      var l = document.createElement('link');
      l.rel = 'prefetch';
      l.href = url;
      document.head.appendChild(l);
    }

    function echange(root, lien) {
      var sec = sectionDe(root);
      if (!sec) return false;
      var url = lien.getAttribute('href');
      if (!url) return false;
      var id = sec.id.replace('shopify-section-', '');
      var ancienNom = root.getAttribute('data-nom-page') || '';
      var nouveauNom = lien.getAttribute('data-nom') || '';
      root.setAttribute('data-bcol-busy', '1');

      charge(url, id).then(function (html) {
        var sas = document.createElement('div');
        sas.innerHTML = String(html).trim();
        var neuf = sas.firstElementChild;
        if (!neuf || neuf.id !== sec.id) throw new Error('section inattendue');
        sec.parentNode.replaceChild(neuf, sec);


        rejoueScripts(neuf);
        neuf.dispatchEvent(new CustomEvent('shopify:section:load', {
          bubbles: true, detail: { sectionId: id, balnia: true },
        }));

        if (ancienNom && nouveauNom && document.title.indexOf(ancienNom) > -1) {
          document.title = document.title.split(ancienNom).join(nouveauNom);
        }
        echangeFait = true;
        history.pushState({ bcol: 1 }, '', url);


        var vue = {
          id: lien.getAttribute('data-pid'),
          handle: lien.getAttribute('data-handle'),
          titre: nouveauNom,
          prix: parseInt(lien.getAttribute('data-prix'), 10) || 0,
          devise: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '',
          url: url,
          source: 'coloris',
        };
        if (window.Shopify && window.Shopify.analytics &&
            typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish('balnia_product_view', vue);
        }
        document.dispatchEvent(new CustomEvent('balnia_product_view', { detail: vue }));
      }).catch(function () {
        window.location.href = url;
      });
      return true;
    }

    function initRoot(root) {
      if (root.dataset.bcolReady) return;
      root.dataset.bcolReady = '1';

      if (root.getAttribute('data-prepare') === '1') {
        var prep = function (e) {
          var a = e.target && e.target.closest ? e.target.closest('[data-bcol-lien]') : null;
          if (a) prepare(root, a);
        };
        root.addEventListener('pointerenter', prep, true);
        root.addEventListener('touchstart', prep, { passive: true });
        root.addEventListener('focusin', prep);
      }

      if (root.getAttribute('data-ajax') !== '1') return;

      root.addEventListener('click', function (e) {
        if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        var a = e.target && e.target.closest ? e.target.closest('[data-bcol-lien]') : null;
        if (!a || a.target) return;
        if (a.origin && a.origin !== window.location.origin) return;
        if (echange(root, a)) e.preventDefault();
      });
    }

    function initAll() {
      var l = document.querySelectorAll('[data-bcol-root]');
      for (var i = 0; i < l.length; i++) initRoot(l[i]);
    }

    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', initAll);

    window.addEventListener('popstate', function () {
      if (echangeFait) window.location.reload();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["balnia-qtyselector"] && !Shopify.designMode) return;
  try {
    (function () {
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents = parts[1] ? decimal + parts[1] : '';
      return dollars + cents;
    }
    function makeMoney(fmt) {
      return function (cents) {
        var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
        var name = m ? m[1] : 'amount';
        var value;
        switch (name) {
          case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
          case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
          case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
          case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', ','); break;
          case 'amount_no_decimals_with_space_separator': value = formatWithDelimiters(cents, 0, ' ', ''); break;
          case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
          default: value = formatWithDelimiters(cents, 2);
        }
        return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
      };
    }
    function debounce(fn, ms) {
      var t; return function () { clearTimeout(t); t = setTimeout(fn, ms); };
    }
    function productForms(root) {
      var out = [], forms = document.querySelectorAll('form[action*="/cart/add"]');
      for (var i = 0; i < forms.length; i++) {
        if (!forms[i].closest('[data-bqs-root]')) out.push(forms[i]);
      }
      return out;
    }

    function initRoot(root) {
      if (root.dataset.bqsReady) return;
      root.dataset.bqsReady = '1';

      // Repli sans accolades litterales : ce bloc JS doit rester 100 % statique.
      var defFmt = '$' + String.fromCharCode(123, 123) + 'amount' + String.fromCharCode(125, 125);
      var money = makeMoney(root.getAttribute('data-money-format') || defFmt);
      var perSuffix = root.getAttribute('data-per-suffix') || '';
      var discType = root.getAttribute('data-disc-type');
      var cmpType = root.getAttribute('data-cmp-type');
      var showCompare = root.getAttribute('data-show-compare') === 'true';
      var showPer = root.getAttribute('data-show-per') === 'true';
      var doSync = root.getAttribute('data-sync') === 'true';
      var perUnit = root.getAttribute('data-per-unit') === 'true';
      var doAjax = root.getAttribute('data-ajax') === 'true';
      var after = root.getAttribute('data-after');
      var addedTxt = root.getAttribute('data-added') || 'Ajoute';
      var paintPrice = root.getAttribute('data-atc-price') === 'true';
      var addUrl = root.getAttribute('data-add-url');
      var cartUrl = root.getAttribute('data-cart-url');
      var unit = parseInt(root.getAttribute('data-unit'), 10) || 0;
      var compare = parseInt(root.getAttribute('data-compare'), 10) || unit;
      var defaultId = root.getAttribute('data-default-id') || '';
      var map = {};
      try { map = JSON.parse(root.getAttribute('data-variants') || '{}'); } catch (e) {}

      var opts = Array.prototype.slice.call(root.querySelectorAll('[data-bqs-opt]'));
      var swatches = Array.prototype.slice.call(root.querySelectorAll('.bp__val'));
      var chosenQty = 1;

      /* ---------- un modele par piece ---------- */
      // Actif seulement quand le produit de la page appartient a une famille
      // reglee dans l'editeur. Sinon, le bloc se comporte comme avant.
      var multi = root.getAttribute('data-multi') === 'true';
      var models = [];
      try { models = JSON.parse(root.getAttribute('data-models') || '[]'); } catch (e) {}
      var byModel = {}, vmap = {};
      for (var mi = 0; mi < models.length; mi++) {
        byModel[String(models[mi].id)] = models[mi];
        for (var vi = 0; vi < models[mi].v.length; vi++) {
          vmap[String(models[mi].v[vi].id)] = models[mi].v[vi];
        }
      }
      var errOne = root.getAttribute('data-err-one') || 'Choisis la taille de la pièce [n]';
      var errMany = root.getAttribute('data-err-many') || 'Choisis la taille des pièces [n]';
      // Derniere taille choisie sur une piece 1 : elle sert de defaut aux
      // pieces suivantes tant qu'elles n'ont pas ete touchees.
      var packSize = '';

      function esc(v) {
        return String(v == null ? '' : v)
          .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
      }
      function rowsOf(card) {
        return card ? Array.prototype.slice.call(card.querySelectorAll('[data-bqs-row]')) : [];
      }
      function allRows() {
        return Array.prototype.slice.call(root.querySelectorAll('[data-bqs-row]'));
      }
      function modelOf(row) { return byModel[String(row.getAttribute('data-mid'))] || models[0]; }
      // Les tailles d'un modele, dans l'ordre du catalogue : une pastille par
      // valeur, avec la variante a ajouter et sa disponibilite.
      function sizesOf(m) {
        var out = [], at = {};
        if (!m || !m.v) return out;
        for (var i = 0; i < m.v.length; i++) {
          var v = m.v[i], key = v.s == null ? '' : String(v.s);
          if (!(key in at)) { at[key] = out.length; out.push({ s: key, id: v.id, a: !!v.a }); }
          else if (v.a && !out[at[key]].a) { out[at[key]].id = v.id; out[at[key]].a = true; }
        }
        return out;
      }
      function sizeInStock(m, size) {
        if (!size) return null;
        var list = sizesOf(m);
        for (var i = 0; i < list.length; i++) if (list[i].s === size && list[i].a) return list[i];
        return null;
      }
      // Prix d'attente d'une piece sans taille : celui de sa premiere variante
      // disponible, pour que le pack affiche un total des la premiere seconde.
      function fallbackVariant(m) {
        if (!m || !m.v || !m.v.length) return null;
        for (var i = 0; i < m.v.length; i++) if (m.v[i].a) return m.v[i];
        return m.v[0];
      }
      function rowVariant(row) {
        var vid = row.getAttribute('data-vid');
        return (vid && vmap[vid]) || fallbackVariant(modelOf(row));
      }

      function paintRow(row) {
        var m = modelOf(row);
        var nameEl = row.querySelector('[data-bqs-uname]');
        if (nameEl) nameEl.textContent = m ? m.t : '';
        // vignettes, pastilles et noms partagent le meme attribut : un seul code
        var thumbs = row.querySelectorAll('[data-bqs-umodel]');
        for (var i = 0; i < thumbs.length; i++) {
          var on = m && thumbs[i].getAttribute('data-mid') === String(m.id);
          thumbs[i].classList.toggle('is-sel', !!on);
          thumbs[i].setAttribute('aria-pressed', on ? 'true' : 'false');
        }
        var msel = row.querySelector('[data-bqs-umodelsel]');
        if (msel && m && msel.value !== String(m.id)) msel.value = String(m.id);
        var wrap = row.querySelector('.bqs__uvals');
        if (!wrap) return;
        var chosen = row.getAttribute('data-size') || '';
        var list = sizesOf(m), html = '';
        for (var j = 0; j < list.length; j++) {
          var on2 = chosen !== '' && list[j].s === chosen && list[j].a;
          html += '<button type="button" class="bqs__uval' + (on2 ? ' is-sel' : '') + (list[j].a ? '' : ' is-out') +
            '" data-bqs-uval data-size="' + esc(list[j].s) + '" data-vid="' + list[j].id + '"' +
            (list[j].a ? '' : ' disabled') + ' aria-pressed="' + (on2 ? 'true' : 'false') + '">' + esc(list[j].s) + '</button>';
        }
        wrap.innerHTML = html;
      }
      // La taille tient si elle est en stock sur le modele de la ligne,
      // sinon elle se vide : on ne laisse jamais une piece sur une rupture.
      function setRowSize(row, size, touched) {
        var hit = sizeInStock(modelOf(row), size);
        if (hit) {
          row.setAttribute('data-size', hit.s);
          row.setAttribute('data-vid', String(hit.id));
        } else {
          row.removeAttribute('data-size');
          row.removeAttribute('data-vid');
        }
        if (touched) row.setAttribute('data-touched', '1');
        row.classList.remove('is-missing');
        paintRow(row);
      }
      function setRowModel(row, mid) {
        if (!byModel[String(mid)]) return;
        row.setAttribute('data-mid', String(mid));
        // Changer de modele ne compte pas comme toucher a la taille : la piece
        // continue de suivre la piece 1 si le client ne l'a pas fixee.
        setRowSize(row, row.getAttribute('data-size') || '', row.getAttribute('data-touched') === '1');
      }
      function spreadSize(size, src) {
        packSize = size || '';
        var rows = allRows();
        for (var i = 0; i < rows.length; i++) {
          if (rows[i] === src || rows[i].getAttribute('data-touched') === '1') continue;
          setRowSize(rows[i], packSize, false);
        }
      }
      /* ---------- une seule taille pour tout le pack ---------- */
      var packOne = !!root.querySelector('[data-bqs-pack]');
      var substTpl = root.getAttribute('data-subst') || '';
      var errPack = root.getAttribute('data-err-pack') || 'Choisis ta taille';
      var mixedTxt = root.getAttribute('data-mixed') || '';
      var compoDefault = root.getAttribute('data-compo-default') === 'mix' ? 'mix' : 'mono';

      function packOf(card) { return card ? card.querySelector('[data-bqs-pack]') : null; }
      function compoOf(card) { return card && card.getAttribute('data-compo') === 'mix' ? 'mix' : 'mono'; }
      function detailOpen(card) { return !!(card && card.getAttribute('data-detail') === '1'); }

      // Le modele d'une piece selon la composition : en mono tout part sur le
      // produit de la page ; en mix on tourne dans la famille, produit de la
      // page en tete. Une famille de 2 sur un pack de 3 donne A, B, A.
      function modelForIndex(i, compo) {
        if (compo !== 'mix' || !models.length) return models[0];
        return models[i % models.length];
      }
      // Une taille peut manquer sur un coloris. Plutot que de la barrer (le
      // client la lit comme epuisee et s'en va), la piece bascule sur le
      // coloris suivant qui l'a en stock. Le produit de la page l'a toujours,
      // puisque la rangee de tailles vient de SON stock : ca aboutit toujours.
      function substitute(m, size) {
        if (!size || !m || sizeInStock(m, size)) return { m: m, from: null };
        var at = 0;
        for (var j = 0; j < models.length; j++) if (models[j].id === m.id) { at = j; break; }
        // On cherche d'abord le coloris SUIVANT dans la famille : se rabattre
        // tout de suite sur le produit de la page annulerait le melange demande.
        for (var i = 1; i <= models.length; i++) {
          var cand = models[(at + i) % models.length];
          if (sizeInStock(cand, size)) return { m: cand, from: m };
        }
        return { m: m, from: null };
      }
      function mixDistinct(card) {
        var rows = rowsOf(card), seen = {}, n = 0;
        for (var i = 0; i < rows.length; i++) {
          var t = modelForIndex(i, 'mix').t;
          if (!(t in seen)) { seen[t] = 1; n++; }
        }
        return n;
      }
      // Recompose les lignes a partir de la composition et de la taille du pack.
      function applyPack(card) {
        var box = packOf(card);
        if (!box) return;
        var compo = compoOf(card), size = card.getAttribute('data-packsize') || '';
        var rows = rowsOf(card);
        for (var i = 0; i < rows.length; i++) {
          // la piece 1 reste le produit de la page, verrouillee
          var want = i === 0 ? models[0] : modelForIndex(i, compo);
          var hit = substitute(want, size);
          if (hit.m) rows[i].setAttribute('data-mid', String(hit.m.id));
          rows[i].removeAttribute('data-touched');
          setRowSize(rows[i], size, false);
          rows[i].setAttribute('data-subst', hit.from ? hit.from.t : '');
        }
        packSize = size;
        paintPack(card);
      }
      // Remet les controles du pack en phase avec l'etat reel des lignes.
      function paintPack(card) {
        var box = packOf(card);
        if (!box) return;
        var rows = rowsOf(card), compo = compoOf(card);
        var sizes = {}, noms = [], substs = [];
        for (var i = 0; i < rows.length; i++) {
          var m = modelOf(rows[i]);
          noms.push(m ? m.t : '');
          sizes[rows[i].getAttribute('data-size') || ''] = 1;
          var sv = rows[i].getAttribute('data-subst');
          if (sv) substs.push({ from: sv, to: m ? m.t : '' });
        }
        var keys = [];
        for (var k in sizes) keys.push(k);
        var one = keys.length === 1 && keys[0] ? keys[0] : '';

        var pv = box.querySelectorAll('[data-bqs-packval]');
        for (var j = 0; j < pv.length; j++) {
          var on = one !== '' && pv[j].getAttribute('data-size') === one;
          pv[j].classList.toggle('is-sel', on);
          pv[j].setAttribute('aria-pressed', on ? 'true' : 'false');
        }
        var chips = box.querySelectorAll('[data-bqs-compo]');
        for (var c = 0; c < chips.length; c++) {
          var sel = chips[c].getAttribute('data-compo') === compo;
          chips[c].classList.toggle('is-sel', sel);
          chips[c].setAttribute('aria-pressed', sel ? 'true' : 'false');
          var tpl = chips[c].getAttribute('data-tpl');
          if (tpl) chips[c].textContent = tpl.replace('[n]', mixDistinct(card));
        }
        var txt = box.querySelector('[data-bqs-compotxt]');
        if (txt) txt.textContent = noms.join(' + ');
        var note = box.querySelector('[data-bqs-packnote]');
        if (note && !box.classList.contains('is-missing')) {
          if (substs.length) {
            note.textContent = substTpl
              .replace('[modele]', substs[0].from)
              .replace('[taille]', one)
              .replace('[remplacant]', substs[0].to);
          } else {
            note.textContent = keys.length > 1 ? mixedTxt : '';
          }
        }
      }
      // Sortie du detail : on relit les lignes plutot que de les ecraser, pour
      // ne pas effacer un pack a tailles melangees que le client vient de poser.
      function syncPackFromRows(card) {
        var rows = rowsOf(card), sizes = {}, mids = {};
        for (var i = 0; i < rows.length; i++) {
          sizes[rows[i].getAttribute('data-size') || ''] = 1;
          mids[rows[i].getAttribute('data-mid')] = 1;
        }
        var sk = [], mk = [];
        for (var a in sizes) sk.push(a);
        for (var b2 in mids) mk.push(b2);
        card.setAttribute('data-packsize', sk.length === 1 && sk[0] ? sk[0] : '');
        card.setAttribute('data-compo', mk.length > 1 ? 'mix' : 'mono');
      }
      function toggleDetail(card, open) {
        var box = packOf(card);
        if (!box) return;
        var zone = card.querySelector('[data-bqs-detail-zone]');
        var btn = box.querySelector('[data-bqs-detail]');
        if (!open) syncPackFromRows(card);
        card.setAttribute('data-detail', open ? '1' : '0');
        if (zone) zone.hidden = !open;
        var hide = box.querySelectorAll('.bqs__packrow,.bqs__compochips,.bqs__compotxt');
        for (var i = 0; i < hide.length; i++) hide[i].hidden = open;
        if (btn) {
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          btn.textContent = open ? (btn.getAttribute('data-close') || '') : (btn.getAttribute('data-open') || '');
        }
        paintPack(card);
        recalc();
        paintAtc();
      }

      /* ---------- l'apercu ----------
         La bulle est creee une seule fois, au premier affichage, et injectee
         dans le BODY : la ligne de modeles peut deborder ou defiler, une bulle
         posee dedans serait coupee. Position fixed, recalculee a chaque
         ouverture depuis le rectangle du controle. */
      var peekOn = root.getAttribute('data-peek') === 'true';
      var peekEl = null, peekFor = null, peekPin = false;
      var peekRaf = 0, peekPos = null, peekScr = null, peekNeuf = false;

      function peekBuild() {
        if (peekEl) return peekEl;
        peekEl = document.createElement('div');
        peekEl.className = 'balnia-peek';
        peekEl.setAttribute('aria-hidden', 'true');
        peekEl.hidden = true;
        var frame = document.createElement('span');
        frame.className = 'balnia-peek__frame';
        var img = document.createElement('img');
        img.alt = '';
        frame.appendChild(img);
        var nom = document.createElement('span');
        nom.className = 'balnia-peek__nom';
        peekEl.appendChild(frame);
        peekEl.appendChild(nom);
        // On recopie les reglages de CETTE liste : la bulle vit dans le body,
        // elle n'herite plus de rien.
        var cs = getComputedStyle(root);
        ['--peek-size', '--peek-pad', '--peek-fit', '--peek-zoom', '--peek-radius',
         '--peek-bg', '--peek-border', '--peek-ink', '--peek-ink-size', '--peek-frame',
         '--peek-name'].forEach(function (v) {
          var val = cs.getPropertyValue(v);
          if (val) peekEl.style.setProperty(v, val.trim());
        });
        document.body.appendChild(peekEl);
        return peekEl;
      }

      function peekHide() {
        peekFor = null;
        peekPin = false;
        peekPos = null;
        peekScr = null;
        if (peekRaf) { cancelAnimationFrame(peekRaf); peekRaf = 0; }
        if (!peekEl) return;
        peekEl.classList.remove('is-on');
        peekEl.hidden = true;
        // display pose sur l'element lui-meme : aucune regle du theme ne peut
        // laisser la bulle a l'ecran par-dessus l'attribut hidden.
        peekEl.style.display = 'none';
        if (window.balniaPeek && window.balniaPeek.close === peekHide) window.balniaPeek.close = null;
      }

      /* Les defilements a surveiller : la fenetre, puis chaque conteneur
         au-dessus de la vignette. Un evenement scroll ne remonte PAS depuis un
         conteneur qui defile, et un theme fait souvent defiler autre chose que
         la fenetre : on ne se fie pas aux evenements, on releve les valeurs et
         on les compare a chaque image. */
      function peekScroll(el) {
        var out = [window.pageYOffset || 0, window.pageXOffset || 0], n = el.parentNode;
        while (n && n.nodeType === 1) { out.push(n.scrollTop, n.scrollLeft); n = n.parentNode; }
        return out;
      }
      function peekDiff(a, c) {
        if (!a || !c || a.length !== c.length) return true;
        for (var i = 0; i < a.length; i++) if (a[i] !== c[i]) return true;
        return false;
      }

      /* Pose la bulle en face de la vignette : au-dessus si la place existe,
         sinon dessous, bornee a 8 px des bords, le bec pointe sur la vignette. */
      function peekPlace(el, btn) {
        var r = btn.getBoundingClientRect();
        var w = el.offsetWidth, h = el.offsetHeight, marge = 8;
        var haut = r.top - h - 10 >= marge;
        var top = haut ? r.top - h - 10 : r.bottom + 10;
        var left = r.left + (r.width - w) / 2;
        var max = (document.documentElement.clientWidth || window.innerWidth) - w - marge;
        if (left > max) left = max;
        if (left < marge) left = marge;
        el.style.top = Math.round(top) + 'px';
        el.style.left = Math.round(left) + 'px';
        el.setAttribute('data-side', haut ? 'haut' : 'bas');
        var fleche = r.left + r.width / 2 - left;
        var rayon = parseInt(getComputedStyle(el).borderRadius, 10) || 10;
        var bord = rayon + 10;
        el.style.setProperty('--fleche', Math.max(bord, Math.min(w - bord, fleche)) + 'px');
        peekPos = { t: r.top, l: r.left };
      }

      /* Le garde-fou, image par image tant que la bulle est ouverte :
         la vignette a quitte la page -> on ferme ; ca a defile -> on ferme,
         c'est la regle ; la mise en page a bouge sans defilement (une image qui
         arrive, une ligne qui se met a jour) -> on repose la bulle au lieu de
         la fermer pour rien. */
      function peekWatch() {
        peekRaf = 0;
        if (!peekFor || !peekEl) return;
        if (!document.contains(peekFor)) { peekHide(); return; }
        var scr = peekScroll(peekFor);
        // la toute premiere image ne compare pas : un clic peut avoir fait
        // defiler la page pour amener la vignette a l'ecran.
        if (peekNeuf) { peekNeuf = false; peekScr = scr; }
        else if (peekDiff(peekScr, scr)) { peekHide(); return; }
        var r = peekFor.getBoundingClientRect();
        if (!r.width && !r.height) { peekHide(); return; }
        if (!peekPos || Math.abs(r.top - peekPos.t) > 0.5 || Math.abs(r.left - peekPos.l) > 0.5) {
          peekPlace(peekEl, peekFor);
        }
        peekRaf = requestAnimationFrame(peekWatch);
      }

      function peekShow(btn, pin) {
        if (!peekOn || !btn) return;
        var m = byModel[String(btn.getAttribute('data-mid'))];
        var src = m && (m.big || m.img);
        // Pas d'image : pas de bulle. Une bulle vide ne renseigne personne.
        if (!src) return;
        if (btn === peekFor) { if (pin) peekPin = true; return; }

        // Une seule bulle ouverte sur la page, meme avec plusieurs listes.
        if (window.balniaPeek && window.balniaPeek.close && window.balniaPeek.close !== peekHide) {
          window.balniaPeek.close();
        }
        if (!window.balniaPeek) window.balniaPeek = {};
        window.balniaPeek.close = peekHide;

        var el = peekBuild();
        peekFor = btn;
        if (pin) peekPin = true;
        el.querySelector('img').src = src;
        el.querySelector('.balnia-peek__nom').textContent = m.t || '';
        el.hidden = false;
        el.style.display = '';

        peekPlace(el, btn);
        peekScr = peekScroll(btn);
        peekNeuf = true;
        el.classList.add('is-on');
        if (!peekRaf) peekRaf = requestAnimationFrame(peekWatch);
      }

      function peekCible(e) {
        return e.target && e.target.closest ? e.target.closest('[data-bqs-umodel]') : null;
      }

      if (peekOn) {
        root.addEventListener('pointerover', function (e) {
          var b2 = peekCible(e);
          if (b2 && !peekPin) peekShow(b2, false);
        });
        root.addEventListener('pointerout', function (e) {
          // au doigt la bulle reste : c'est un tap ailleurs qui la ferme.
          // epinglee, elle reste aussi quand le curseur part.
          if (peekPin || (e.pointerType && e.pointerType !== 'mouse')) return;
          var b2 = peekCible(e);
          if (b2 && b2 === peekFor) peekHide();
        });
        // le clic epingle, un second clic sur la meme vignette depingle
        root.addEventListener('click', function (e) {
          var b2 = peekCible(e);
          if (!b2) return;
          if (peekPin && b2 === peekFor) { peekHide(); return; }
          peekPin = false;
          peekFor = null;
          peekShow(b2, true);
        });
        root.addEventListener('focusin', function (e) {
          var b2 = peekCible(e);
          if (b2) peekShow(b2, false);
        });
        root.addEventListener('focusout', function () { if (!peekPin) peekHide(); });
        document.addEventListener('pointerdown', function (e) {
          if (!peekCible(e)) peekHide();
        }, true);
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape') peekHide(); });
        // scroll ne remonte pas : en capture sur le document on attrape aussi
        // celui d'un conteneur interne, pas seulement celui de la fenetre.
        document.addEventListener('scroll', peekHide, { capture: true, passive: true });
        window.addEventListener('scroll', peekHide, { passive: true });
        window.addEventListener('resize', peekHide);
        window.addEventListener('orientationchange', peekHide);
      }

      function missingRows() {
        if (!multi) return [];
        var rows = rowsOf(activeCard()), out = [];
        for (var i = 0; i < rows.length; i++) if (!rows[i].getAttribute('data-vid')) out.push(rows[i]);
        return out;
      }
      function clearMissing() {
        var rows = allRows();
        for (var i = 0; i < rows.length; i++) rows[i].classList.remove('is-missing');
        var boxes = root.querySelectorAll('[data-bqs-uerr]');
        for (var j = 0; j < boxes.length; j++) { boxes[j].textContent = ''; boxes[j].hidden = true; }
        var packs = root.querySelectorAll('[data-bqs-pack]');
        for (var k2 = 0; k2 < packs.length; k2++) {
          packs[k2].classList.remove('is-missing');
          var pc = packs[k2].closest('[data-bqs-card]');
          // la note reprend son contenu normal : substitution, ou rien
          if (pc) paintPack(pc);
        }
      }
      // Ajout sans taille : pas de pop-up. Le libelle de la ligne s'allume, le
      // message s'affiche sous les lignes, le focus part sur la premiere
      // taille disponible.
      function flagMissing(rows) {
        var acard = activeCard(), abox = packOf(acard);
        // Detail ferme : les lignes de piece sont masquees, un focus dedans
        // serait un no-op silencieux. Le rappel se joue sur le pack.
        if (abox && !detailOpen(acard)) {
          abox.classList.add('is-missing');
          var pnote = abox.querySelector('[data-bqs-packnote]');
          if (pnote) pnote.textContent = errPack;
          focusFirst(abox);
          return;
        }
        var nums = [];
        for (var i = 0; i < rows.length; i++) {
          rows[i].classList.add('is-missing');
          nums.push(rows[i].getAttribute('data-idx'));
        }
        var list = nums.length > 1 ? nums.slice(0, -1).join(', ') + ' et ' + nums[nums.length - 1] : nums[0];
        var card = activeCard();
        var box = card ? card.querySelector('[data-bqs-uerr]') : null;
        if (box) {
          box.textContent = (nums.length > 1 ? errMany : errOne).replace('[n]', list);
          box.hidden = false;
        }
        focusFirst(rows[0]);
      }
      // Le sticky ATC peut declencher l'ajout alors que la ligne fautive est
      // hors ecran, ou posee sous la barre collante : on la ramene au centre
      // avant de donner le focus, comme le fait deja balnia-buybar.
      function focusFirst(scope) {
        var first = scope && scope.querySelector('[data-bqs-uval]:not([disabled]),[data-bqs-packval]:not([disabled])');
        if (!first) return;
        if (first.scrollIntoView) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
        try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); }
      }

      function cardOf(el) { return el ? el.closest('[data-bqs-card]') : null; }
      function activeCard() { return root.querySelector('[data-bqs-card].is-active'); }

      function currentId() {
        var forms = productForms(root);
        for (var i = 0; i < forms.length; i++) {
          var el = forms[i].querySelector('[name="id"]');
          if (el && el.value) return el.value;
        }
        return defaultId;
      }

      /* ---------- choix des variantes ---------- */
      function readSelection() {
        var sel = {};
        for (var i = 0; i < swatches.length; i++) {
          if (swatches[i].classList.contains('is-sel')) {
            sel[swatches[i].getAttribute('data-pos')] = swatches[i].getAttribute('data-val');
          }
        }
        return sel;
      }
      function matchVariant(sel) {
        for (var id in map) {
          var v = map[id];
          if (sel['1'] && v.o1 !== sel['1']) continue;
          if (sel['2'] && v.o2 !== sel['2']) continue;
          if (sel['3'] && v.o3 !== sel['3']) continue;
          return id;
        }
        return null;
      }
      function availWith(sel, pos, val) {
        for (var id in map) {
          var v = map[id];
          if (v['o' + pos] !== val) continue;
          var ok = true;
          for (var p in sel) {
            if (p !== pos && sel[p] && v['o' + p] !== sel[p]) { ok = false; break; }
          }
          if (ok && v.a) return true;
        }
        return false;
      }
      // Repercute le choix sur TOUS les selecteurs de variante de la page
      // (celui du bloc Achat par exemple), pour qu'ils restent d'accord.
      function mirror(pos, val) {
        var all = document.querySelectorAll('.bp__val[data-pos="' + pos + '"]');
        for (var i = 0; i < all.length; i++) {
          all[i].classList.toggle('is-sel', all[i].getAttribute('data-val') === val);
        }
        var labels = document.querySelectorAll('[data-bp-optsel="' + pos + '"]');
        for (var j = 0; j < labels.length; j++) labels[j].textContent = val;
      }
      function applyVariant() {
        if (!swatches.length) return;
        var sel = readSelection();
        for (var i = 0; i < swatches.length; i++) {
          var s = swatches[i];
          s.classList.toggle('is-out', !availWith(sel, s.getAttribute('data-pos'), s.getAttribute('data-val')));
        }
        var id = matchVariant(sel);
        if (!id) return;
        unit = map[id].p; compare = map[id].c;
        var forms = productForms(root);
        for (var f = 0; f < forms.length; f++) {
          var el = forms[f].querySelector('[name="id"]');
          if (el && el.value !== String(id)) {
            el.value = id;
            el.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        recalc();
      }
      if (swatches.length) {
        root.addEventListener('click', function (e) {
          var btn = e.target && e.target.closest ? e.target.closest('.bp__val') : null;
          if (!btn || btn.classList.contains('is-out')) return;
          mirror(btn.getAttribute('data-pos'), btn.getAttribute('data-val'));
          applyVariant();
        });
      }

      // Ecrit la quantite choisie dans le formulaire produit de la page.
      // Aucun ajout au panier ici : c'est ton propre bouton qui s'en charge.
      function pushQty() {
        if (!doSync) return;
        var forms = productForms(root);
        for (var i = 0; i < forms.length; i++) {
          var qi = forms[i].querySelector('[name="quantity"]');
          if (!qi) continue;
          if (parseInt(qi.value, 10) === chosenQty) continue;
          qi.value = chosenQty;
          qi.dispatchEvent(new Event('input', { bubbles: true }));
          qi.dispatchEvent(new Event('change', { bubbles: true }));
        }
        document.dispatchEvent(new CustomEvent('balnia:quantity', { detail: { quantity: chosenQty } }));
      }

      function recalc() {
        for (var k = 0; k < opts.length; k++) {
          var el = opts[k];
          var qty = parseInt(el.getAttribute('data-qty'), 10) || 1;
          var pct = parseFloat(el.getAttribute('data-pct')) || 0;
          var fixed = parseInt(el.getAttribute('data-fixed'), 10) || 0;
          var rows = multi ? rowsOf(cardOf(el)) : [];
          var total = 0, cmpTotal = 0, after = 0;
          if (rows.length) {
            // La remise d'affichage s'applique au prix reel de chaque piece :
            // un pack peut melanger des modeles au prix different.
            for (var r = 0; r < rows.length; r++) {
              var rv = rowVariant(rows[r]);
              var pu = rv ? rv.p : unit;
              var pc = rv ? rv.c : pu;
              var ro = discType === 'fixed' ? fixed : Math.round(pu * pct / 100);
              var ra = pu - ro; if (ra < 0) ra = 0;
              total += ra;
              cmpTotal += (cmpType === 'original' && pc > pu) ? pc : pu;
            }
            after = Math.round(total / rows.length);
          } else {
            var off = discType === 'fixed' ? fixed : Math.round(unit * pct / 100);
            after = unit - off; if (after < 0) after = 0;
            total = after * qty;
            var cmpUnit = (cmpType === 'original' && compare > unit) ? compare : unit;
            cmpTotal = cmpUnit * qty;
          }
          var savings = cmpTotal - total; if (savings < 0) savings = 0;
          var pctnum = cmpTotal > 0 ? Math.round(savings * 100 / cmpTotal) : 0;

          var totalEl = el.querySelector('[data-bqs-total]');
          if (totalEl) totalEl.innerHTML = money(total);
          var cmpEl = el.querySelector('[data-bqs-compare]');
          if (cmpEl) {
            if (showCompare && savings > 0) { cmpEl.innerHTML = money(cmpTotal); cmpEl.removeAttribute('hidden'); }
            else { cmpEl.setAttribute('hidden', ''); }
          }
          var perEl = el.querySelector('[data-bqs-per]');
          if (perEl && showPer) perEl.innerHTML = money(after) + ' ' + perSuffix;
          var saveEl = el.querySelector('[data-bqs-save]');
          if (saveEl) {
            var tpl = saveEl.getAttribute('data-tpl') || '';
            saveEl.innerHTML = tpl.replace('[%]', pctnum + '%').replace('[$]', money(savings));
          }
        }
      }

      function syncVariant() {
        var id = currentId();
        if (id && map[id]) { unit = map[id].p; compare = map[id].c; }
        recalc();
      }

      function select(el) {
        for (var k = 0; k < opts.length; k++) {
          var c = cardOf(opts[k]);
          if (c) c.classList.remove('is-active');
          opts[k].setAttribute('aria-pressed', 'false');
        }
        var mine = cardOf(el);
        if (mine) mine.classList.add('is-active');
        if (mine && packOf(mine)) paintPack(mine);
        el.setAttribute('aria-pressed', 'true');
        chosenQty = parseInt(el.getAttribute('data-qty'), 10) || 1;
        clearMissing();
        pushQty();
        pushFirstUnit();
        recalc();
        paintAtc();
      }

      for (var k = 0; k < opts.length; k++) {
        (function (el) { el.addEventListener('click', function () { select(el); }); })(opts[k]);
      }

      /* ---------- une taille par piece ---------- */
      // Les pastilles de piece n'utilisent pas la classe .bp__val exprès : elles
      // ne doivent pas etre confondues avec le selecteur de variante global.
      root.addEventListener('click', function (e) {
        if (!e.target || !e.target.closest) return;
        // Les controles du pack passent EN TETE : la pastille de taille du pack
        // n'est pas dans une ligne de piece, elle tomberait sinon dans la
        // branche heritee qui deplace is-sel sans jamais ecrire data-vid.
        var pv = e.target.closest('[data-bqs-packval]');
        if (pv) {
          if (pv.disabled || pv.classList.contains('is-out')) return;
          var pcard = pv.closest('[data-bqs-card]');
          if (!pcard) return;
          pcard.setAttribute('data-packsize', pv.getAttribute('data-size') || '');
          clearMissing();
          applyPack(pcard);
          pushFirstUnit();
          recalc();
          paintAtc();
          return;
        }
        var cp = e.target.closest('[data-bqs-compo]');
        if (cp) {
          var ccard = cp.closest('[data-bqs-card]');
          if (!ccard) return;
          ccard.setAttribute('data-compo', cp.getAttribute('data-compo') === 'mix' ? 'mix' : 'mono');
          clearMissing();
          applyPack(ccard);
          pushFirstUnit();
          recalc();
          paintAtc();
          return;
        }
        var dt = e.target.closest('[data-bqs-detail]');
        if (dt) {
          var dcard = dt.closest('[data-bqs-card]');
          if (!dcard) return;
          clearMissing();
          toggleDetail(dcard, !detailOpen(dcard));
          return;
        }
        var th = e.target.closest('[data-bqs-umodel]');
        if (th) {
          var trow = th.closest('[data-bqs-row]');
          if (!trow) return;
          setRowModel(trow, th.getAttribute('data-mid'));
          clearMissing();
          pushFirstUnit();
          recalc();
          paintAtc();
          return;
        }
        var u = e.target.closest('[data-bqs-uval]');
        if (!u || u.disabled || u.classList.contains('is-out')) return;
        var row = u.closest('[data-bqs-row]');
        if (row) {
          setRowSize(row, u.getAttribute('data-size'), true);
          if (row.getAttribute('data-idx') === '1') spreadSize(u.getAttribute('data-size'), row);
          clearMissing();
        } else {
          var grp = u.parentNode.querySelectorAll('[data-bqs-uval]');
          for (var i = 0; i < grp.length; i++) grp[i].classList.remove('is-sel');
          u.classList.add('is-sel');
        }
        pushFirstUnit();
        recalc();
        paintAtc();
      });
      root.addEventListener('change', function (e) {
        if (!e.target || !e.target.matches) return;
        if (e.target.matches('[data-bqs-umodelsel]')) {
          var srow = e.target.closest('[data-bqs-row]');
          if (!srow) return;
          setRowModel(srow, e.target.value);
          clearMissing();
          pushFirstUnit();
          recalc();
          paintAtc();
          return;
        }
        if (e.target.matches('[data-bqs-unit]')) {
          pushFirstUnit();
          paintAtc();
        }
      });

      // Ce que chaque piece du pack actif a choisi, dans l'ordre.
      function unitPicks() {
        var card = activeCard(), out = [];
        if (!card) return out;
        if (multi) {
          var mrows = rowsOf(card);
          for (var m = 0; m < mrows.length; m++) {
            var vid = mrows[m].getAttribute('data-vid');
            if (vid) out.push(vid);
          }
          return out;
        }
        var rows = card.querySelectorAll('.bqs__unit');
        for (var i = 0; i < rows.length; i++) {
          var sel = rows[i].querySelector('select[data-bqs-unit]');
          if (sel && sel.value) { out.push(sel.value); continue; }
          var on = rows[i].querySelector('[data-bqs-uval].is-sel');
          if (on) out.push(on.getAttribute('data-vid'));
        }
        return out;
      }

      // Le formulaire produit ne transporte qu'un seul identifiant de variante :
      // on y met celle de la premiere piece, pour que tout reste coherent si
      // l'ajout se fait finalement par la voie native.
      function pushFirstUnit() {
        if (!perUnit) return;
        var picks = unitPicks();
        if (!picks.length) return;
        // Le formulaire produit ne porte que le produit de la page : on n'y
        // ecrit pas la variante d'un autre modele du pack.
        if (!map[String(picks[0])]) return;
        var forms = productForms(root);
        for (var f = 0; f < forms.length; f++) {
          var el = forms[f].querySelector('[name="id"]');
          if (el && el.value !== String(picks[0])) {
            el.value = picks[0];
            el.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        if (map[picks[0]]) { unit = map[picks[0]].p; compare = map[picks[0]].c; recalc(); }
      }

      // Le bouton d'ajout affiche le prix du pack, pas celui d'une seule piece.
      function paintAtc() {
        if (!paintPrice) return;
        var card = activeCard(); if (!card) return;
        var tot = card.querySelector('[data-bqs-total]'); if (!tot) return;
        var btns = document.querySelectorAll('[data-bp-atc]');
        for (var i = 0; i < btns.length; i++) {
          if (btns[i].disabled) continue;
          btns[i].setAttribute('data-atc-price', 'false');
          var lbl = btns[i].querySelector('[data-bp-atc-label]');
          if (!lbl) continue;
          var base = btns[i].getAttribute('data-atc-text') || lbl.textContent;
          var next = base + ' · ' + tot.textContent;
          /* On n'ecrit que si le texte change vraiment. Reecrire la meme
             valeur reste une mutation du DOM, et un declencheur GTM qui
             observe les changements du DOM sur le bouton d'ajout la compte
             comme un evenement : un clic sur une carte de quantite envoyait
             alors un AddToCart sans que rien ne soit ajoute au panier. */
          if (lbl.textContent !== next) lbl.textContent = next;
        }
      }

      /* ---------- ajout au panier ---------- */
      // Plusieurs tailles dans un meme pack, c'est plusieurs lignes de panier :
      // le formulaire produit ne sait pas faire, on passe par l'API panier.
      // Un identifiant de variante valable : un entier positif present dans le
      // catalogue de la page. Tout le reste est ecarte, c'est ce qui provoquait
      // la page d'erreur « Nous n'avons pas trouve de variantes ».
      function cleanId(v) {
        var n = parseInt(v, 10);
        if (!n || n < 1) return 0;
        return (map[String(n)] || vmap[String(n)]) ? n : 0;
      }

      function buildItems() {
        var by = {}, out = [], picks = perUnit ? unitPicks() : [];
        for (var i = 0; i < picks.length; i++) {
          var pid = cleanId(picks[i]);
          if (pid) by[pid] = (by[pid] || 0) + 1;
        }
        for (var id in by) out.push({ id: parseInt(id, 10), quantity: by[id] });
        if (!out.length) {
          var one = cleanId(currentId()) || cleanId(defaultId);
          if (one) out.push({ id: one, quantity: chosenQty });
        }
        return out;
      }

      var errEl = root.querySelector('[data-bqs-err]');
      function showErr(msg) {
        if (!errEl) { if (msg) console.error('[balnia quantite]', msg); return; }
        if (msg) { errEl.textContent = msg; errEl.hidden = false; }
        else { errEl.textContent = ''; errEl.hidden = true; }
      }

      function onSubmit(e) {
        if (!doAjax) return;
        var form = e.currentTarget;
        // On coupe toujours la soumission classique : le formulaire produit ne
        // sait transporter qu'une variante, il enverrait un panier faux.
        e.preventDefault();
        e.stopPropagation();
        showErr('');

        clearMissing();
        var miss = missingRows();
        if (miss.length) { flagMissing(miss); return; }

        var items = buildItems();
        if (!items.length) {
          showErr('Choisis une taille avant d\'ajouter au panier.');
          return;
        }
        var btn = form.querySelector('[data-bp-atc]') || form.querySelector('[type="submit"]');
        var lbl = btn ? btn.querySelector('[data-bp-atc-label]') : null;
        var old = lbl ? lbl.textContent : '';
        if (btn) btn.disabled = true;
        if (lbl) lbl.textContent = '...';
        function restore() {
          if (btn) btn.disabled = false;
          if (lbl) lbl.textContent = old;
        }
        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) {
            return r.json().catch(function () { return {}; }).then(function (data) {
              if (!r.ok) {
                // Shopify renvoie le motif exact : rupture, quantite max, etc.
                var msg = data.description || data.message || ('Ajout refusé (' + r.status + ')');
                throw new Error(msg);
              }
              return data;
            });
          })
          .then(function () {
            /* Un pack de 2 en S + M, c'est 2 lignes de panier donc 2 evenements
               Shopify, pour un seul clic du client. On en publie un seul. */
            if (window.balniaATC) {
              window.balniaATC.signal({
                items: items.map(function (it) {
                  return {
                    id: it.id,
                    quantity: it.quantity,
                    // un pack peut melanger des modeles : le prix se lit
                    // aussi dans le catalogue de la famille, sinon le signal
                    // AddToCart partirait a 0 pour les pieces 2 et 3
                    price: ((map[String(it.id)] || vmap[String(it.id)] || {}).p) || 0
                  };
                }),
                source: 'pdp'
              });
            }
            document.dispatchEvent(new CustomEvent('cart:change'));
            if (after === 'cart') { window.location.href = cartUrl; return; }
            restore();
            if (lbl) { lbl.textContent = addedTxt; setTimeout(function () { lbl.textContent = old; paintAtc(); }, 1600); }
            if (after === 'drawer' && typeof window.openCartDrawer === 'function') window.openCartDrawer();
          })
          .catch(function (err) {
            // On reste sur la page et on dit pourquoi, plutot que de renvoyer
            // vers la page d'erreur Shopify sans explication.
            restore();
            showErr((err && err.message) || 'Ajout au panier impossible.');
            console.error('[balnia quantite] envoi', items, err);
          });
      }
      function bindForms() {
        var forms = productForms(root);
        for (var i = 0; i < forms.length; i++) {
          if (forms[i].dataset.bqsBound) continue;
          forms[i].dataset.bqsBound = '1';
          forms[i].addEventListener('submit', onSubmit, true);
        }
      }
      bindForms();
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindForms);
      window.addEventListener('load', bindForms);

      if (multi) {
        var rows0 = allRows();
        for (var r0 = 0; r0 < rows0.length; r0++) paintRow(rows0[r0]);
      }
      if (packOne) {
        var cards0 = root.querySelectorAll('[data-bqs-card]');
        for (var c0 = 0; c0 < cards0.length; c0++) {
          if (!packOf(cards0[c0])) continue;
          cards0[c0].setAttribute('data-compo', compoDefault);
          cards0[c0].setAttribute('data-detail', '0');
          applyPack(cards0[c0]);
        }
      }

      var pre = root.querySelector('[data-bqs-opt][aria-pressed="true"]') || opts[0];
      if (pre) select(pre);

      // La variante peut changer via les pastilles de la section produit
      // (qui ecrivent la propriete value, pas l'attribut) : on relit apres coup.
      var deb = debounce(syncVariant, 90);
      document.addEventListener('click', deb, true);
      document.addEventListener('change', deb, true);

      // Si un autre bloc modifie la quantite, on garde l'option cochee en phase.
      document.addEventListener('input', function (e) {
        var t = e.target;
        if (!t || t.name !== 'quantity' || t.closest('[data-bqs-root]')) return;
        var v = parseInt(t.value, 10) || 1;
        if (v === chosenQty) return;
        for (var i = 0; i < opts.length; i++) {
          if ((parseInt(opts[i].getAttribute('data-qty'), 10) || 1) === v) {
            for (var j = 0; j < opts.length; j++) {
              var cj = cardOf(opts[j]);
              if (cj) cj.classList.remove('is-active');
              opts[j].setAttribute('aria-pressed', 'false');
            }
            var ci = cardOf(opts[i]);
            if (ci) ci.classList.add('is-active');
            opts[i].setAttribute('aria-pressed', 'true');
            chosenQty = v;
            paintAtc();
            return;
          }
        }
      });

      applyVariant();
      syncVariant();
      paintAtc();
    }

    function initAll() {
      var roots = document.querySelectorAll('[data-bqs-root]');
      for (var i = 0; i < roots.length; i++) initRoot(roots[i]);
    }
    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["balnia-quantity-bundle"] && !Shopify.designMode) return;
  try {
    (function () {
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents = parts[1] ? decimal + parts[1] : '';
      return dollars + cents;
    }
    function makeMoney(fmt) {
      return function (cents) {
        var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
        var name = m ? m[1] : 'amount';
        var value;
        switch (name) {
          case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
          case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
          case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
          case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', ','); break;
          case 'amount_no_decimals_with_space_separator': value = formatWithDelimiters(cents, 0, ' ', ''); break;
          case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
          default: value = formatWithDelimiters(cents, 2);
        }
        return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
      };
    }
    function debounce(fn, ms) { var t; return function () { clearTimeout(t); t = setTimeout(fn, ms); }; }

    function initRoot(root) {
      if (root.dataset.bqbReady) return;
      root.dataset.bqbReady = '1';

      // Repli du format monétaire sans accolades litterales (JS 100% statique).
      var defFmt = '$' + String.fromCharCode(123, 123) + 'amount' + String.fromCharCode(125, 125);
      var money = makeMoney(root.getAttribute('data-money-format') || defFmt);
      var perSuffix = root.getAttribute('data-per-suffix') || '';
      var discType = root.getAttribute('data-disc-type');
      var cmpType = root.getAttribute('data-cmp-type');
      var showCompare = root.getAttribute('data-show-compare') === 'true';
      var showPer = root.getAttribute('data-show-per') === 'true';
      var unit = parseInt(root.getAttribute('data-unit'), 10) || 0;
      var compare = parseInt(root.getAttribute('data-compare'), 10) || unit;
      var defaultId = root.getAttribute('data-default-id') || '';
      var map = {};
      try { map = JSON.parse(root.getAttribute('data-variants') || '{}'); } catch (e) {}

      var opts = Array.prototype.slice.call(root.querySelectorAll('[data-bqb-opt]'));
      var myForm = root.querySelector('.bqb__form');
      var myBtn = root.querySelector('[data-bqb-add]');
      var idInput = root.querySelector('[data-bqb-idinput]');
      var qtyInput = root.querySelector('[data-bqb-qtyinput]');
      var chosenQty = 1;

      // Le vrai bouton d'achat de la page (bloc balnia-buy), hors de notre bloc.
      function findMainForm() {
        var forms = document.querySelectorAll('form[action*="/cart/add"]');
        for (var i = 0; i < forms.length; i++) { if (!root.contains(forms[i])) return forms[i]; }
        return null;
      }
      var mainForm = findMainForm();
      var mainBtn = document.querySelector('[data-bp-atc]');
      if (mainBtn && root.contains(mainBtn)) mainBtn = null;
      if (!mainBtn && mainForm) {
        mainBtn = mainForm.querySelector('button[name="add"], [type="submit"][name="add"], [type="submit"]');
      }

      // Variante active : input [name="id"] présent sur la page (hors bloc), sinon défaut.
      function currentId() {
        var inputs = document.querySelectorAll('[name="id"]');
        for (var i = 0; i < inputs.length; i++) {
          if (!root.contains(inputs[i]) && inputs[i].value) return inputs[i].value;
        }
        return defaultId;
      }
      function syncVariant() {
        var id = currentId();
        if (id && map[id]) { unit = map[id].p; compare = map[id].c; }
        if (idInput && id) idInput.value = id;
        recalc();
      }

      function recalc() {
        for (var k = 0; k < opts.length; k++) {
          var el = opts[k];
          var qty = parseInt(el.getAttribute('data-qty'), 10) || 1;
          var pct = parseFloat(el.getAttribute('data-pct')) || 0;
          var fixed = parseInt(el.getAttribute('data-fixed'), 10) || 0;
          var off = discType === 'fixed' ? fixed : Math.round(unit * pct / 100);
          var after = unit - off; if (after < 0) after = 0;
          var total = after * qty;
          var cmpUnit = (cmpType === 'original' && compare > unit) ? compare : unit;
          var cmpTotal = cmpUnit * qty;
          var savings = cmpTotal - total; if (savings < 0) savings = 0;
          var pctnum = cmpTotal > 0 ? Math.round(savings * 100 / cmpTotal) : 0;

          var totalEl = el.querySelector('[data-bqb-total]');
          if (totalEl) totalEl.innerHTML = money(total);
          var cmpEl = el.querySelector('[data-bqb-compare]');
          if (cmpEl) {
            if (showCompare && savings > 0) { cmpEl.innerHTML = money(cmpTotal); cmpEl.removeAttribute('hidden'); }
            else { cmpEl.setAttribute('hidden', ''); }
          }
          var perEl = el.querySelector('[data-bqb-per]');
          if (perEl && showPer) perEl.innerHTML = money(after) + ' ' + perSuffix;
          var saveEl = el.querySelector('[data-bqb-save]');
          if (saveEl) {
            var tpl = saveEl.getAttribute('data-tpl') || '';
            saveEl.innerHTML = tpl.replace('[%]', pctnum + '%').replace('[$]', money(savings));
          }
        }
      }

      function select(el) {
        for (var k = 0; k < opts.length; k++) {
          opts[k].classList.remove('is-active');
          opts[k].setAttribute('aria-pressed', 'false');
        }
        el.classList.add('is-active');
        el.setAttribute('aria-pressed', 'true');
        chosenQty = parseInt(el.getAttribute('data-qty'), 10) || 1;
        if (qtyInput) qtyInput.value = chosenQty;
      }

      for (var k = 0; k < opts.length; k++) {
        (function (el) { el.addEventListener('click', function () { select(el); }); })(opts[k]);
      }
      var pre = root.querySelector('[data-bqb-opt].is-active') || opts[0];
      if (pre) select(pre);

      function flash(btn) {
        var added = btn.getAttribute('data-added');
        if (!added) return;
        var lbl = btn.querySelector('[data-bqb-label]') || btn;
        var base = btn.getAttribute('data-label') || lbl.textContent;
        lbl.textContent = added;
        setTimeout(function () { lbl.textContent = base; }, 1600);
      }

      // Ajout au panier : on écrit la quantité et on relaie le vrai bouton
      // d'achat (drawer du thème). Sans bouton principal : soumission native
      // de notre form vers /cart/add.
      if (myForm) {
        myForm.addEventListener('submit', function (e) {
          if (myBtn && myBtn.disabled) { e.preventDefault(); return; }
          var id = currentId();
          if (idInput && id) idInput.value = id;
          if (qtyInput) qtyInput.value = chosenQty;
          // On ne relaie le bouton du theme que s'il est reellement cliquable.
          // Desactive, un clic dessus ne fait rien : dans ce cas on laisse
          // notre propre formulaire partir, avec la bonne variante.
          var relayable = mainForm && mainBtn && !mainBtn.disabled &&
                          mainBtn.getAttribute('aria-disabled') !== 'true';
          if (relayable) {
            e.preventDefault();
            var mq = mainForm.querySelector('[name="quantity"]');
            if (mq) {
              mq.value = chosenQty;
              mq.dispatchEvent(new Event('input', { bubbles: true }));
              mq.dispatchEvent(new Event('change', { bubbles: true }));
            }
            mainBtn.click();
            if (myBtn) flash(myBtn);
          }
          // sinon : le form se soumet nativement (POST /cart/add) avec id + quantity.
        });
      }

      // Le prix suit la variante choisie ailleurs sur la page.
      document.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('.bp__val')) setTimeout(syncVariant, 40);
      });
      document.addEventListener('change', debounce(syncVariant, 60));

      // L'etat epuise se lit sur LA variante choisie, pas sur le bouton du
      // theme. Le recopier revenait a bloquer tout le produit des qu'une
      // seule taille etait epuisee, alors que les autres restaient en stock.
      var SOLD_TEXT = 'Épuisé';
      var PROD_AVAILABLE = root.getAttribute('data-prod-available') === 'true';
      function variantAvailable() {
        var id = currentId();
        if (id && map[id] && typeof map[id].a === 'boolean') return map[id].a;
        return PROD_AVAILABLE;
      }
      function syncDisabled() {
        if (!myBtn) return;
        var ok = variantAvailable();
        myBtn.disabled = !ok;
        var lbl = myBtn.querySelector('[data-bqb-label]');
        if (lbl) lbl.textContent = ok ? (myBtn.getAttribute('data-label') || lbl.textContent) : SOLD_TEXT;
      }
      syncDisabled();
      document.addEventListener('change', debounce(syncDisabled, 60));
      document.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('.bp__val')) setTimeout(syncDisabled, 40);
      });

      syncVariant();
    }

    function initAll() {
      var roots = document.querySelectorAll('[data-bqb-root]');
      for (var i = 0; i < roots.length; i++) initRoot(roots[i]);
    }
    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', initAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
